import ErrorMessage from 'components/ErrorMessage'
import OButton from 'components/reusable/OButton'
import useToastContext from 'hooks/useToastContext'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { apiGet, apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { TiDelete } from 'react-icons/ti'
import { useTranslation } from 'react-i18next'
import FormData from 'form-data'
import OInputField from 'components/reusable/OInputField'
import formValidation from 'utils/formValidation'
import OTextArea from 'components/reusable/OTextArea'
import OFileInput from 'components/reusable/OFileInput'

const AddMarketing = ({ setShowModal, allMarketing }) => {
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    shouldFocusError: true
  })
  const notification = useToastContext()
  const addMerchantLoading = false
  const [userNameArray, setUserNameArray] = useState([])

  const [availableFor, setAvailableFor] = useState('')
  const [isError, setIsError] = useState(true)
  const [userError, setUserError] = useState('')
  const [userIds, setUserIds] = useState([])
  const [keyword, setKeyword] = useState('')
  const [isAllUser, setIsAllUser] = useState(false)

  const getAllUser = async () => {
    try {
      const payloadUser = keyword.trim()

      const path = `${apiPath.marketingManagerSearchUser}?email=${payloadUser}`
      const result = await apiGet(path)
      if (result?.data?.success) {
        const response = result?.data?.results
        setKeyword('')
        setAvailableFor('specific')
        const checkUser = userIds.some(previous => previous === response?._id)
        if (!checkUser) {
          setUserNameArray(item => item.concat({ ...response }))
          setUserIds(ids => ids.concat(response?._id))
        }
        setUserError('')
      } else {
        notification.error(result?.data?.message)
      }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }
  const handleSelectAllUsers = event => {
    if (event.target.checked) {
      setIsAllUser(event.target.checked)
      setUserNameArray([])
      setUserIds([])
      setAvailableFor('all')
      setUserError('')
    } else {
      setIsAllUser(event.target.checked)
    }
  }

  const onSubmit = async data => {
    try {
      if (!data?.file[0]) {
        setIsError('Please upload pdf file.')
        return
      }
      if (!availableFor) {
        setUserError('Please select at least one user.')
        return
      }
      const formData = new FormData()
      formData.append('subjectLine', data.subjectLine)
      formData.append('description', data.description)
      formData.append('sendTo', availableFor)
      if (userIds.length > 0) formData.append('user', userIds)
      formData.append('file', data.file[0])
      reset()

      const res = await apiPost(apiPath.Addmarketing, formData)
      if (res.data.success) {
        setShowModal(false)
        notification.success(res?.data?.message)
        allMarketing()
      } else {
        notification.error(res?.data?.message)
      }
    } catch (err) {
      console.log('err:', err)
    }
  }

  return (
    <div>
      <>
        <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
          <div className='relative my-6  w-full max-w-[1150px] mx-auto'>
            <div className='sm:py-4 sm:px-2 py-8 px-7 '>
              <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>
                <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                  <h3 className='text-xl font-semibold'>
                    {t('ADD_MARKETING_FORM')}
                  </h3>
                  <button
                    className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                    onClick={() => setShowModal(false)}
                  >
                    <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                      ×
                    </span>
                  </button>
                </div>
                <div className='relative p-6 flex-auto'>
                  <div className='grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2'>
                    <div className='px-2'>
                      {/* <div className='relative z-0 mb-6 w-full group'>
                        <input
                          type='text'
                          id='SubjectLine'
                          maxLength={15}
                          autocomplete="off"
                          className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                          placeholder=' '
                          {...register('subjectLine', {
                            required: ' Subject Line is required.',
                            minLength: {
                              value: 2,
                              message: 'Minimum length must be 2.'
                            },
                            validate: value => {
                              return value.trim()
                                ? true
                                : 'White spaces not allowed.'
                            }
                          })}
                        />
                        <label
                          htmlFor='name'
                          className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                        >
                          {t('O_SUBJECT_LINE')}
                          <span className='text-red-500'>*</span>
                        </label>
                        <ErrorMessage message={errors?.subjectLine?.message} />
                      </div> */}
                      <OInputField
                        wrapperClassName=''
                        name='subjectLine'
                        inputLabel={
                          <>
                            {t('O_SUBJECT_LINE')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='text'
                        autoFocus
                        register={register(
                          'subjectLine',
                          formValidation.subjectLine
                        )}
                        errors={errors}
                      />
                    </div>
                    <div className='px-2'>
                      <OFileInput
                        wrapperClassName='relative z-0 w-full group'
                        name='videos'
                        inputLabel={
                          <>
                            {t('O_UPLOAD_PDF')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        accept='application/pdf'
                        // register={register('videos')}
                        errors={errors}
                        register={register('file', {
                          onChange: event => {
                            const valid = event.target.value.slice(-4)
                            if (valid === '.pdf') {
                              setIsError('')
                            } else {
                              setIsError('Please upload pdf file.')
                            }
                          }
                        })}
                      />

                      <ErrorMessage message={isError} />
                    </div>
                    <div className='px-2'>
                      {/* <div className='relative z-0 mb-6 w-full group'>
                        <textarea
                          name='description'
                          id='description'
                          placeholder=' '
                          className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none max-w-lg focus:ring-0  peer'
                          {...register('description', {
                            required: 'Description is required.',
                            minLength: {
                              value: 2,
                              message: 'Minimum length must be 2.'
                            },
                            validate: value => {
                              return value.trim()
                                ? true
                                : 'White spaces not allowed.'
                            }
                          })}
                        />
                        <label
                          htmlFor='address'
                          className='peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
                        >
                          {t('O_MARKETING_DESCRIPTION')}
                          <span className='text-red-500'>*</span>
                        </label>
                        <ErrorMessage message={errors?.description?.message} />
                      </div> */}
                      <OTextArea
                        wrapperClassName='relative z-0 mb-6 w-full '
                        name='description'
                        inputLabel={
                          <>
                            {t('O_MARKETING_DESCRIPTION')}
                            <span className='text-red-500'>*</span>
                          </>
                        }
                        type='textarea'
                        register={register('description', {
                          required: 'Description is required.',
                          minLength: {
                            value: 2,
                            message: 'Minimum length must be 2.'
                          },
                          validate: value =>
                            value.trim() ? true : 'White spaces not allowed.'
                        })}
                        errors={errors}
                      />
                    </div>
                    <div className='px-2'>
                      <div className='relative z-0 mb-6 w-full group flex'>
                        <div className='flex items-center w-[200px]'>
                          <input
                            id='default-checkbox'
                            type='checkbox'
                            checked={isAllUser}
                            onChange={e => handleSelectAllUsers(e)}
                            className='w-4 cursor-pointer h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600'
                          />
                          <label
                            htmlFor='default-checkbox'
                            className='ml-2 text-sm font-medium cursor-pointer text-gray-900 dark:text-gray-300'
                          >
                            {t('O_ALL_USERS')}
                          </label>
                        </div>
                      </div>
                      {!isAllUser && (
                        <>
                          <p className='block  text-sm font-medium text-gray-900 dark:text-white  '>
                            {t('MERCHANT_SEARCH_BY_EMAIL')}
                          </p>
                          <div className='flex items-center '>
                            <input
                              type='search'
                              id='default-search'
                              title=''
                              className='block p-2.5 mr-2 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300   dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white w-[70%]'
                              // placeholder={t('MERCHANT_SEARCH_BY_EMAIL')}
                              value={keyword}
                              onChange={event => setKeyword(event.target.value)}
                            />
                            <OButton
                              label={<>{t('USERS_ADD_USER')}</>}
                              onClick={getAllUser}
                            />
                          </div>
                        </>
                      )}
                      {userError && <ErrorMessage message={userError} />}
                    </div>

                    {userNameArray?.length !== 0 &&
                      userNameArray.map(item => (
                        <div
                          key={item._id}
                          className='md:py-4 sm:px-2 sm:py-8 px-7'
                        >
                          <div>
                            <div className='p-3 mt-2 rounded-md  w-full text-black text-base border-2 flex items-center justify-between'>
                              {item?.firstName + ' ' + item?.lastName}
                              <div>
                                <TiDelete
                                  className='w-7 h-7 cursor-pointer'
                                  onClick={() => {
                                    setUserIds(
                                      userIds.filter(id => id !== item._id)
                                    )
                                    setUserNameArray(
                                      userNameArray.filter(
                                        user => user._id !== item._id
                                      )
                                    )
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                  <button
                    className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                    type='button'
                    onClick={() => setShowModal(false)}
                  >
                    {t('O_BACK')}
                  </button>
                  {addMerchantLoading ? (
                    <div className='spinner-container'>
                      <div className='loading-spinner'></div>
                    </div>
                  ) : (
                    <OButton
                      label={<>{t('O_ADD')}</>}
                      type='submit'
                      onClick={handleSubmit(onSubmit)}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='opacity-25 fixed inset-0 z-40 bg-black' />
      </>
    </div>
  )
}

export default AddMarketing
